import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="validators--ring-size"
export default class extends Controller {
  static values = {
    message: { type: String, default: "Please select a ring size" }
  }

  static targets = ["select"]

  connect() {
    console.log('Ring Size Validator connected')
  }

  checkRingSize(event) {
    console.log('Checking ring size...')
    const ringSizeSelect = this.hasSelectTarget 
      ? this.selectTarget 
      : document.getElementById('ring_size')
    
    console.log('Ring size select:', ringSizeSelect)
    console.log('Ring size value:', ringSizeSelect?.value)
    
    if (ringSizeSelect && ringSizeSelect.value === '') {
      event.preventDefault()
      alert(this.messageValue)
      ringSizeSelect.focus()
      return false
    }
    
    return true
  }
}
